module.exports = __webpack_public_path__ + "assets/2-San-Francisco-Sales-Recruiter.e967e298.png";